// extracted by mini-css-extract-plugin
module.exports = {"insurance":"Insurance_insurance__VEHlV","header":"Insurance_header__1ZMpq","title":"Insurance_title__3WuYU","btnWrapper":"Insurance_btnWrapper__2UrUV"};